document.addEventListener("DOMContentLoaded", () => {

  const modal = document.getElementById("subscription-modal");
  const openBtn = document.getElementById("open-subscription-modal");
  const closeBtn = modal.querySelector(".subscription-close");
  const buyNowBtn = document.getElementById("subscription-buy-now");

  /* ==============================
     MODAL OPEN / CLOSE
  ============================== */

  openBtn.onclick = () => {
    modal.classList.remove("hidden");
    syncVariantOptions();
    setupStartDate();
    calculatePrice();
  };

  closeBtn.onclick = () => {
    modal.classList.add("hidden");
  };

  /* ==============================
     SYNC VARIANT OPTIONS
  ============================== */

  function syncVariantOptions() {
    /* SIZE */
    const sizeSelect = document.getElementById("subscription-size");
    sizeSelect.innerHTML = "";

    document.querySelectorAll(".option-name-size input[type=radio]").forEach(radio => {
      sizeSelect.innerHTML +=
        `<option value="${radio.value}" ${radio.checked ? "selected" : ""}>${radio.value}</option>`;
    });


    /* GRIND / STYLE (dynamic detection) */
    const typeSelect = document.getElementById("subscription-grind");
    const typeLabel = document.getElementById("subscription-grind-label");

    const coffeeWrapper = document.getElementById("subscription-coffee-wrapper");
    const coffeeSelect = document.getElementById("subscription-coffeetype");

    typeSelect.innerHTML = "";
    coffeeSelect.innerHTML = "";

    let typeRadios = document.querySelectorAll(".option-name-style input[type=radio]");

    if (typeRadios.length === 0) {

      // GRIND case
      typeRadios = document.querySelectorAll(".option-name-grind input[type=radio]");
      if (typeLabel) typeLabel.innerText = "Grind Style";

      if (coffeeWrapper) coffeeWrapper.classList.add("hidden");

    } else {

      // ROAST STYLE case
      if (typeLabel) typeLabel.innerText = "Roast Style";

      if (coffeeWrapper) coffeeWrapper.classList.remove("hidden");

      /* Populate Coffee Type */
      document.querySelectorAll(".option-name-coffee input[type=radio]").forEach(radio => {
        coffeeSelect.innerHTML +=
          `<option value="${radio.value}" ${radio.checked ? "selected" : ""}>${radio.value}</option>`;
      });

    }

    typeRadios.forEach(radio => {
      typeSelect.innerHTML +=
        `<option value="${radio.value}" ${radio.checked ? "selected" : ""}>${radio.value}</option>`;
    });

  }

  /* ==============================
     MATCH VARIANT FROM MODAL
  ============================== */

  function getMatchedVariant() {
    const selectedSize = document.getElementById("subscription-size").value;
    const selectedGrind = document.getElementById("subscription-grind").value;

    const coffeeSelect = document.getElementById("subscription-coffeetype");
    const selectedCoffee = coffeeSelect ? coffeeSelect.value : null;

    const variants = JSON.parse(
      document.getElementById("ProductVariantsJSON").textContent
    );

    return variants.find(v => {
      const matchSize = v.options.includes(selectedSize);
      const matchGrind = v.options.includes(selectedGrind);

      const matchCoffee = selectedCoffee
        ? v.options.includes(selectedCoffee)
        : true;

      return matchSize && matchGrind && matchCoffee;
    });
  }

  /* ==============================
     PRICE CALCULATION
  ============================== */

  function calculatePrice() {
    const deliveriesSelect = document.getElementById("subscription-deliveries");
    const deliveries = parseInt(deliveriesSelect.value);

    const discountPercent = parseFloat(
      deliveriesSelect.options[deliveriesSelect.selectedIndex].dataset.discount
    );

    const matchedVariant = getMatchedVariant();
    if (!matchedVariant) return;

    const originalTotal = (matchedVariant.price / 100) * deliveries;
    let finalTotal = originalTotal;

    if (!isNaN(discountPercent)) {
      finalTotal -= (finalTotal * discountPercent / 100);
    }

    const finalPriceEl = document.getElementById("subscription-final-price");
    const originalPriceEl = document.getElementById("subscription-original-price");
    const discountLabelEl = document.getElementById("subscription-discount-label");

    finalPriceEl.innerText = `₹${Math.round(finalTotal)}`;

    if (discountPercent > 0) {
      originalPriceEl.innerText = `₹${Math.round(originalTotal)}`;
      discountLabelEl.innerText = `(${discountPercent}% OFF)`;
      originalPriceEl.classList.remove("hidden");
      discountLabelEl.classList.remove("hidden");
    } else {
      originalPriceEl.classList.add("hidden");
      discountLabelEl.classList.add("hidden");
    }
  }

  document.querySelectorAll(
    "#subscription-deliveries, #subscription-size, #subscription-grind, #subscription-coffeetype"
  ).forEach(el => {
    if (el) el.addEventListener("change", calculatePrice);
  });

  /* ==============================
     START DATE (DEFAULT + RESTRICT)
  ============================== */

  function setupStartDate() {
    const dateInput = document.getElementById("subscription-start-date");
    if (!dateInput) return;

    const today = new Date();

    const formatDate = d => {
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${y}-${m}-${day}`;
    };

    dateInput.min = formatDate(today);

    const defaultDate = new Date(today);
    defaultDate.setDate(today.getDate() + 7);
    dateInput.value = formatDate(defaultDate);
  }

  /* ==============================
     BUY NOW → CLEAR CART → ADD → CHECKOUT
  ============================== */

  buyNowBtn.onclick = function () {

    if (buyNowBtn.classList.contains("loading")) return;

    const startDate = document.getElementById("subscription-start-date").value;
    if (!startDate) {
      alert("Please select a subscription start date");
      return;
    }

    const matchedVariant = getMatchedVariant();
    if (!matchedVariant) {
      alert("Selected variant is unavailable");
      return;
    }

    buyNowBtn.classList.add("loading");

    const deliveries = parseInt(
      document.getElementById("subscription-deliveries").value
    );

    const formData = {
      id: matchedVariant.id,
      quantity: deliveries,
      properties: {
        "Purchase Type": "Subscription",
        "Deliveries": deliveries,
        "Size": document.getElementById("subscription-size").value,
        "Coffee Type": document.getElementById("subscription-coffeetype")?.value || "",
        "Grind": document.getElementById("subscription-grind").value,
        "Frequency": document.getElementById("subscription-frequency").value,
        "Start Date": startDate
      }
    };

    fetch("/cart/clear.js", { method: "POST" })
      .then(() => fetch("/discount/remove"))
      .then(() => fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData)
      }))
      .then(() => {
        const deliveries = document.getElementById("subscription-deliveries").value;

        const couponMap = {
          "3": "Subscription of 3 Deliveries",
          "6": "Subscription of 6 Deliveries",
          "12": "Subscription of 12 Deliveries",
          "18": "Subscription of 18 Deliveries",
          "24": "Subscription of 24 Deliveries"
        };
        const couponCode = couponMap[deliveries];        
        // 1️⃣ Remove any existing discount
        fetch('/discount/remove')
          .then(() => {
            // 2️⃣ Apply new coupon & go to checkout
            window.location.href =
              `/discount/${encodeURIComponent(couponCode)}?redirect=/checkout`;
          });
      })
      .catch(err => {
        console.error("Subscription checkout error:", err);
        buyNowBtn.classList.remove("loading");
      });
  };

});


document.addEventListener('DOMContentLoaded', function () {

  setTimeout(() => {

    const params = new URLSearchParams(window.location.search);

    const isSubscription = params.get('subscription');
    const deliveryParam = params.get('delivery');

    if (isSubscription === 'true') {

      // Preselect delivery
      if (deliveryParam) {
        const select = document.getElementById('subscription-deliveries');

        if (select) {
          Array.from(select.options).forEach(opt => {
            if (opt.value === deliveryParam) {
              opt.selected = true;
            }
          });

          select.dispatchEvent(new Event('change'));
        }
      }

      // Open modal
      const openBtn = document.getElementById('open-subscription-modal');
      if (openBtn) {
        openBtn.click();
      }

    }

  }, 500); // try 300–800ms if needed

});